/**
 * CoreDisposable.ts
 * @author Diao Zheng
 * @file A base class for Disposable interfaces that simply implements the
 * IDisposable interface.
 */
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _isDisposed;
import { Disposable } from "./Disposable";
export class CoreDisposable {
    constructor() {
        _isDisposed.set(this, false);
    }
    get [(_isDisposed = new WeakMap(), Disposable.IsDisposed)]() {
        return __classPrivateFieldGet(this, _isDisposed);
    }
}
